import {
    Component,
    inject,
    Inject,
    InjectionToken,
    Injector,
    OnInit,
    Optional,
    ViewEncapsulation,
} from '@angular/core';
import { DataFieldEditBase } from '@fi-app/data-field/data-field-edit/data-field-edit-base';
import { AppTextService } from '@fi-shared/app-text';
import { FiCustomValidatorPatterns } from '@fi-shared/fi-custom-validator-patterns/fi-custom-validator-patterns';
import { UserModel } from '@fi-app/user/user.model';
import { FiUserSignInSettings } from '@fi-app/user/user-edit/fi-user-sign-in-settings';

export type TFiUserEditDataFieldName_Settings = {
    isDisabledFunc: () => boolean;
    LoginNameLabel?: string;
    fiUserSignInSettings: FiUserSignInSettings;
};

export const FiUserEditDataFieldName_Settings = new InjectionToken<TFiUserEditDataFieldName_Settings>(
    'FiUserEditDataFieldName_Settings',
);

@Component({
    selector: 'fi-user-edit-data-field-name',
    templateUrl: './name.component.html',
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-user-edit-data-field-name' },
    standalone: false,
})
export class FiUserEditDataFieldNameComponent extends DataFieldEditBase implements OnInit {
    fiUserSignInSettings: FiUserSignInSettings;

    get user() {
        return this.dataFieldObject as UserModel;
    }

    constructor(
        injector: Injector,
        @Optional() @Inject(FiUserEditDataFieldName_Settings) private settings: TFiUserEditDataFieldName_Settings,
    ) {
        super(injector);
    }

    ngOnInit() {
        this.fiUserSignInSettings = this.settings.fiUserSignInSettings;
    }

    isDisabled(): boolean {
        return this.settings && this.settings.isDisabledFunc ? this.settings.isDisabledFunc() : false;
    }

    getUserNameLabel(): string {
        return this.settings.LoginNameLabel || this.appTextService.get('common.username');
    }

    private appTextService: AppTextService = inject(AppTextService);

    protected readonly FiCustomValidatorPatterns = FiCustomValidatorPatterns;
}
